import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { formStyle } from '../../TransitionStyles';
import FormTitle from '../FormTitle';

DiffDeptInputs.propTypes = {
  fieldName: PropTypes.string,
};

export default function DiffDeptInputs({ fieldName }) {
  const { control, getValues } = useFormContext();

  const diffDeptDoneByStaffId = useWatch({
    control,
    name: `${fieldName}.doneByStaffTypeId`,
  });

  const staffField = useMemo(() => {
    const newFieldName = Object.entries(getValues()).find(
      ([, value]) => String(value?.staffTypeId) === String(diffDeptDoneByStaffId)
    )?.[0];

    return newFieldName ?? fieldName;
  }, [diffDeptDoneByStaffId]);

  //This needs to be broken out as a separate component
  //so that the values update correctly every time staffField value changes
  const DiffDeptInputsView = ({ staffField }) => {
    const staff = useWatch({
      control,
      name: `${staffField}.staffMembers`,
    });

    return staff
      ?.filter((x) => !x.deleteFlag)
      ?.map((s, index) => (
        <Grid key={`${staffField}${index}`} container spacing={1} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'First name' }} />
            <TextField fullWidth size="small" type="text" disabled value={s.firstName ?? ''} sx={formStyle} />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Last name' }} />
            <TextField fullWidth size="small" type="text" disabled value={s.lastName ?? ''} sx={formStyle} />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Cell phone' }} />
            <TextField fullWidth size="small" type="text" disabled value={s.cellPhone ?? ''} sx={formStyle} />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <FormTitle fieldAttributes={{ questionTitle: 'Email' }} />
            <TextField fullWidth size="small" type="text" disabled value={s.email ?? ''} sx={formStyle} />
          </Grid>
        </Grid>
      ));
  };

  return <DiffDeptInputsView staffField={staffField} key={staffField} />;
}
